export default {
  400: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Bad Request (400)</strong></p><div><p>You may have typed the URL incorrectly or you may be accessing the page from an outdated link. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Clear your browser’s cache / cookies.</li>
        <li>Try again later. </li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  401: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Unauthorized (401)</strong></p><div><p>We are sorry. You are not authorised to access this page. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  403: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Forbidden (403)</strong></p><div><p>You do not have sufficient administrative permission to view this page. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  404: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Not Found (404)</strong></p><div><p>This page may have been removed or the link is outdated. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  408: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Request Time Out (408)</strong></p><div><p>This request is taking too long to process without any response from the server. You can either check the internet connection or refresh the page. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  500: (
    currentDate,
    correlationId = null
  ) => `<p><strong>Internal Server Error (500)</strong></p>
    <div>
      <p>To resolve this error, please try the following:</p>
      <div>
        <ol class="xb-ol">
        <li>Use Private Incognito Mode (for Google Chrome) or Private Window (for all other browsers), and</li>
        <li>Log out and re-login to ACEAS.</li>
        </ol>
        <br />
        <p>We apologise for the inconvenience caused, and appreciate your patience and understanding during this period.</p>
        <br />
        ${correlationId ? `<p>Correlation ID : ${correlationId}</p>` : ""}
        <p>Date and Time : ${currentDate}</p>
    </div>
    </div>`,
  502: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Bad Gateway (502)</strong></p><div><p>The service is temporarily unable to process your request. Alternatively, you may try following: </p></div>
    <di">
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Reload the web page.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  503: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Service Unavailable (503)</strong></p><div><p>The service is temporarily unable to process your request. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Reload the web page.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `,
  504: (
    currentDate,
    hereHyperlinkURL
  ) => `<p><strong>Gateway Time Out (504)</strong></p><div><p>The service is temporarily unable to process your request. Alternatively, you may try following: </p></div>
    <div>
        <ul class="xb-ul">
        <li>Ensure the URL entered is correct.</li>
        <li>Reload the web page.</li>
        <li>Clear your browser’s cache / cookies.</li>
        </ul>
        <br />
        <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;" href="${hereHyperlinkURL}">HERE</a>.</p>
        <p>Date and Time : ${currentDate}</p>
    </div>
    `
};
